// deps
import React, { Suspense, useState, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Link
} from "react-router-dom";

import ScrollToTop from './components/ScrollToTop/ScrollToTop';


import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
// import Offcanvas from 'react-bootstrap/Offcanvas';

import { useTranslation } from 'react-i18next';
import { GoogleOAuthProvider } from '@react-oauth/google';
// style
import './App.css';
// Components
import Header from './layout/Header';
import Loader from './components/Loader';
import ProtectedRoute  from './components/ProtectedRoute'
import SearchInput from './components/SearchInput';

// Utils
import {
  FaHome, FaUsers, FaFile,
  FaBookOpen, FaNewspaper,
  FaList,
  FaBuilding
} from "react-icons/fa";

import { 
  HiExternalLink, 
  HiOfficeBuilding 
} from "react-icons/hi";

//api
import { getSettings } from "./api/settings";
import { getLangByKey } from "./api/languages";

// TODO: remove dummy data cwhen connect
import data from './dummy_data';
import { useAppStore } from "./context/state";

import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Authors from './pages/Author';
import Books from './pages/Book';
import LogOut from './pages/Logout';
import AboutMe from './pages/About';
import ShoppingCart from './pages/ShoppingCart';

// Pages
const ActivateMe = React.lazy(() => import('./pages/ActivateForm'));
const Forgot = React.lazy(() => import('./pages/Forgot'));
const Profile = React.lazy(() => import('./pages/Profile'));
// const ShoppingCart = React.lazy(() => import('./pages/ShoppingCart'));
const AdminBoard = React.lazy(() => import('./pages/AdminBoard'));

const App = () => {

  const [gclientId, setGClientId] = useState("");  // TODO: Set data from API
  // eslint-disable-next-line

  const defaultLocale =  useAppStore.getState().locale
  const [lang, setLang] = useState(defaultLocale);
  const { i18n } = useTranslation();

  const setSettings = (data) => useAppStore.setState({ settings: data })
  const setLanguage = (data) => useAppStore.setState({ language: data })
  const setLocales = (data) => useAppStore.setState({ locales: data })
  const setBooks = (data) => useAppStore.setState({ books: data })
  const setAuthors = (data) => useAppStore.setState({ authors: data })
  const setRandom = (data) => useAppStore.setState({ random: data })
  
  // eslint-disable-next-line no-unused-vars
  const [resources, setResources] = useState(i18n.options.resources);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true)


  const changeLanguage=(key)=>{
    getLangByKey(key)
      .then(response=>{
        const { data } = response;
        resources[data.locale] = {'translation':data.language}
        // resources.push(resource)
        setResources(resources)
        setLang(key)
      })
      .catch(err=>{})
  }

  useEffect(() => {
      getSettings().then(response =>{
        const { data } = response;
        const { settings, authors, books, random, language, locales } = data
  
        setGClientId(settings.gclientId)

        setSettings(settings)
        setLanguage(language)
        setLocales(locales)
        setBooks(books)
        setAuthors(authors)
        setRandom(random)
        setLoading(false)
        
        console.log(">>>>>>> ", "reload app", books);

      })
      
  }, []);

  useEffect(() => {
  }, [i18n.language]);

  
  let translation = resources[lang].translation

  const DropdownTitle = () => (<> <FaList size={20}/> Colecciones </>);
  const DropPublish = () => (<> <FaFile size={20}/> Publicaciones </>);
  
  return (
    <GoogleOAuthProvider clientId={gclientId}>
      <BrowserRouter>
      <ScrollToTop />
          <Navbar 
            id='mainnavbar'
            bg="primary" 
            expand="sm"  
            style={{ zIndex: 0 }} 
          >
            <Container fluid className="container-navbar">
            <Navbar.Toggle aria-controls="mainnavbar"/>
            <Navbar.Collapse id="mainnavbar"
              className='red-navbar'
            >
            <Nav
              className="my-2 my-lg-0"
            >
            <Nav.Link as={Link} to="/editorial/">
              <FaHome size={20} />
              {' '}INICIO
            </Nav.Link>
            <Nav.Link as={Link} to="/editorial/authors">
              <FaUsers size={20} />
              {' '}AUTORES
            </Nav.Link>
            <Nav.Link as={Link} to="/editorial/books">
              <FaBookOpen size={20} />
              {' '}CATÁLOGO
            </Nav.Link>
            
            <Nav.Link as={Link} to="/editorial/books/createdAt/last/sort">
              <FaNewspaper size={20} />
              {' '}NOVEDADES
            </Nav.Link>

            <a class="nav-link" href="https://humanidades.univalle.edu.co/" target='_blank'>
              <FaBuilding size={20} />
              {' '}FACULTAD DE HUMANIDADES
            </a>       
         

            </Nav>

            <SearchInput
              query={query}
              setQuery={setQuery}
              to={"/editorial/books/"}
            /> 

            </Navbar.Collapse>
            </Container>
          </Navbar>
          {/* Finish main navbar */}
          
          {/* <Navbar id="secondbar" key="first" expand="false" 
            style={{ zIndex:1, background:"#dadadb", color:'#000'}} 
          >
          <Container fluid className="mx-auto container-navbar">
          <NavDropdown title={<DropPublish/>} id="drop-menu" style={{ zIndex:1, color:'#555'}}>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/editorial">La editorial</NavDropdown.Item>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/editorial-rules">Directriz editorial</NavDropdown.Item>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/editorial-team">Equipo de trabajo</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/editorial-manual">Guias y manuales</NavDropdown.Item>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/editorial-help">Ayuda</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title={<DropdownTitle/>} id="drop-menu" style={{color:'#555'}}>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/books/audience/group">Por Audiencia</NavDropdown.Item>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/books/primaryContentType/group">Por Contenido</NavDropdown.Item>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/books/fileFormat/group">Por formato</NavDropdown.Item>
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/books/editorial/group">Por editorial</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item className="text-primary" as={Link} to="/editorial/books/bisac/group">De acuerdo Bisac</NavDropdown.Item>
          </NavDropdown>

          <a href="https://humanidades.univalle.edu.co/" target="_blank" rel="noreferrer" style={{color:'#555'}}>
            <HiOfficeBuilding size={20} />
            {' '} Facultad
          </a>

          <a href="https://www.univalle.edu.co/" target="_blank" rel="noreferrer" style={{color:'#555'}}>
            <HiExternalLink size={20} />
            {' '} Universidad del Valle
          </a>

            {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-false`} /> */}
            {/* <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-false`}
              aria-labelledby={`offcanvasNavbarLabel-expand-false`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
                    
                  </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body> */}
                  {/* <Nav className="justify-content-end flex-grow-1 pe-3">
                    <NavDropdown title={
                    <DropPublish/>
                    } id="drop-menu">
                    <NavDropdown.Item className="text-primary" as={Link} to="">La editorial</NavDropdown.Item>
                    <NavDropdown.Item className="text-primary" as={Link} to="">Directriz editorial</NavDropdown.Item>
                    <NavDropdown.Item className="text-primary" as={Link} to="">Equipo de trabajo</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item className="text-primary" as={Link} to="">Guias y manuales</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title={
                    <DropdownTitle/>
                    } id="drop-menu">
                    <NavDropdown.Item className="text-primary" as={Link} to="">Por Género</NavDropdown.Item>
                    <NavDropdown.Item className="text-primary" as={Link} to="">Por Facultad</NavDropdown.Item>
                    <NavDropdown.Item className="text-primary" as={Link} to="">Por Autores</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item className="text-primary" as={Link} to="">De tipo electrónico</NavDropdown.Item>
                    <NavDropdown.Item className="text-primary" as={Link} to="">De tipo impreso</NavDropdown.Item>
                    <NavDropdown.Item className="text-primary" as={Link} to="">De acuerdo al Interés</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link as={Link} to="/">
                        <FaRainbow size={20} />
                        {' '} Editorial
                    </Nav.Link>
                  </Nav> */}
              {/* </Offcanvas.Body> */}
            {/* </Navbar.Offcanvas> */}
          {/* </Container>
          </Navbar> */}
          {/* Finish second navbar */}

          <div className="container home interna pt-3">
            <Header
                changeLanguage={changeLanguage}
                lang={translation}
                />
            {/* {authLoading
            ? 
            <Loader />
            : <React.Suspense fallback={
            <Loader />
            } > */}
            <Routes>
                <Route path="/editorial/" element={
                  <Home 
                    loading={loading}
                    lang={translation}
                  />
                } />
                {/* <Route path="/editorial" element={
                  <Home lang={translation} />
                } /> */}
                <Route path="/editorial/authors/*" element={
                <Authors
                  letters={data.authorletters}
                  gallery={data.authors}
                  />
                } />
                <Route path="/editorial/books/*" element={
                  <Books
                    letters={data.bookletters}
                    gallery={data.books}
                    lang={translation}
                    ordered={false}
                    query={query}
                    setQuery={setQuery}
                    />
                } />
                                
                <Route path="/editorial/shopping-cart" element={
                  <ShoppingCart  
                    lang={translation}
                  />
                }>
                </Route>
                
                <Route path="/editorial/publish" element={
                  <AboutMe
                    content="howpublish"
                    path="/editorial/publish"
                  />
                } />

                <Route path="/editorial/contact" element={
                  <AboutMe
                    content="contact"
                    path="/editorial/contact"
                  />
                } />
                <Route path="/editorial/about" element={
                  <AboutMe
                    content="about"
                  />
                } />                
                <Route path="/editorial/editorial" element={
                  <AboutMe
                    content="about"
                    path="/editorial/about"
                  />
                } />
                <Route path="/editorial/editorial-rules" element={
                  <AboutMe
                    content="editorialrules"
                    path="/editorial/about"
                  />
                } />
                <Route path="/editorial/editorial-team" element={
                  <AboutMe
                    content="editorialteam"
                    path="/editorial/about"
                  />
                } />
                <Route path="/editorial/editorial-manual" element={
                  <AboutMe
                    content="editorialmanual"
                    path="/editorial/about"
                  />
                } />
                <Route path="/editorial/editorial-help" element={
                  <AboutMe
                    content="editorialhelp"
                    path="/editorial/about"
                  />
                } />

                <Route path="/editorial/app-privacy-policy" element={
                  <AboutMe
                    content="privacy-policy"
                    path="/editorial/about"
                  />
                } />
                <Route path="/editorial/app-service-condition" element={
                  <AboutMe
                    content="service-condition"
                    path="/editorial/about"
                  />
                } />

                <Route path="/editorial/user-access" element={
                <SignIn
                  gclientId={gclientId}
                  lang={translation} />
                } />
                <Route path="/editorial/user-register" element={
                <SignUp
                  gclientId={gclientId}
                  lang={translation} />
                } />
                <Route path="/editorial/user-logout" element={
                  <LogOut 
                    lang={translation}
                    />
                } />
                <Route path="/editorial/user-activate/:code" element={
                <ActivateMe
                  lang={translation}
                  />
                } />
                
                <Route path="/editorial/user-forgot-password" element={
                  <Suspense fallback={<Loader />} >
                    <Forgot lang={translation} />
                  </Suspense>
                } />

                <Route path="/editorial/user-profile/*" element={
                    <Suspense fallback={<Loader />} >
                      <ProtectedRoute element={Profile} lang={translation} />
                    </Suspense>
                  }>
                </Route>
                <Route path="/editorial/control-panel/*" element={
                  <Suspense fallback={<Loader />} >
                    <ProtectedRoute 
                      element={AdminBoard} 
                      lang={translation} 
                    />
                  </Suspense>
                }>
                </Route>
                <Route path='/' element={ <Navigate to="/editorial" /> }/>
                <Route path="*" element={ <Navigate to="/editorial" /> } />
            </Routes>
            {/* </React.Suspense>
            }*/}
          </div>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
